import styled from "styled-components";

//color control
const baseColor = 'rgb(200,200,200)';
const baseColorHover = 'rgb(255, 255, 255)';
const baseColorActive = 'rgb(176,253,253)';
//animate control
const baseBoxShadow = '1.5px 1.5px 2px 0px #000000';
const baseBoxShadowHover = '2.5px 2.5px 5px 0px #000000';
const baseBoxShadowActive = '0px 0px 0px 0px #000000';

export const InfoDiv = styled.div`
    width: 50px;
    height: 50px;
    font-size: 2em;
    border-radius: 25px;
    background: ${baseColor};
    padding:5px 5px 5px 5px;
    position: absolute;
    right:${props => props.tip ? '-100px' : '30px'};
    bottom:30px;
    -webkit-box-shadow: ${baseBoxShadow};
            box-shadow: ${baseBoxShadow};
    -webkit-transition: 0.2s all ease-out;
    -o-transition: 0.2s all ease-out;
    transition: 0.2s all ease-out;
    :hover {
        background: ${baseColorHover};
        -webkit-box-shadow: ${baseBoxShadowHover};
            box-shadow: ${baseBoxShadowHover};
    }
    :active {
        background: ${baseColorActive};
        -webkit-box-shadow: ${baseBoxShadowActive};
                box-shadow: ${baseBoxShadowActive};
    }
    :focus {
        outline:0;
    }
    z-index:500;
    cursor: pointer;
`
export const EntranceDiv = styled.div`
    width: 50px;
    height: 50px;
    font-size: 2em;
    border-radius: 25px;
    background: ${baseColor};
    padding:5px 5px 5px 5px;
    position: absolute;
    right:${props => props.entrance ? '-100px' : '30px'};
    bottom:90px;
    -webkit-box-shadow: ${baseBoxShadow};
            box-shadow: ${baseBoxShadow};
    -webkit-transition: 0.2s all ease-out;
    -o-transition: 0.2s all ease-out;
    transition: 0.2s all ease-out;
    :hover {
        background: ${baseColorHover};
        -webkit-box-shadow: ${baseBoxShadowHover};
            box-shadow: ${baseBoxShadowHover};
    }
    :active {
        background: ${baseColorActive};
        -webkit-box-shadow: ${baseBoxShadowActive};
                box-shadow: ${baseBoxShadowActive};
    }
    :focus {
        outline:0;
    }
    z-index: 500;
    cursor: pointer;
`
export const ActiveButton = styled.button`
    width: 200px;
    height: 40px;
    font-size: 1.2em;
    font-weight: 900;
    font-family: arial, "Microsoft JhengHei", "微軟正黑體", sans-serif !important;
    border: none;
    border-radius: 5px;
    background: ${baseColor};
    margin:5px 5px 5px 5px;
    -webkit-transition: 0.1s all ease-out;
    -o-transition: 0.1s all ease-out;
    transition: 0.1s all ease-out;
    :hover {
        position: relative;
        top: -2px;
        background: ${baseColorHover};
        -webkit-box-shadow: ${baseBoxShadowHover};
                box-shadow: ${baseBoxShadowHover};
    }
    :active {
        position: relative;
        top: 0px;
        background: ${baseColorActive};
        -webkit-box-shadow: ${baseBoxShadowActive};
                box-shadow: ${baseBoxShadowActive};
        }
    :focus {
        outline:0;
    }
    cursor: pointer;
`;
